import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';

function TechSpecs() {
  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <Paper style={{ padding: 20 }}>
          <Typography variant="h5" gutterBottom>
            Technical Specifications
          </Typography>
          <Typography variant="body1" gutterBottom>
            All installations are completed by NEPTUNE TECHNOLOGY PTE. LTD. personnel who are fully trained and accredited. All work is carried out in accordance with current regulations and IMDA standards. Every installation is completed with full test documentation for Fibre Optic & Category 5e/6 and is offered complete with 1 year warranty. Outlet layout plans and numbering systems are also available to ensure that additions and alterations can be carried out effectively.
          </Typography>
          <Typography variant="body1" gutterBottom>
            <ul>
              <li>Full network design service</li>
              <li>Category 5 enhanced and Category 6</li>
              <li>Fibre-optic installations and testing</li>
              <li>Wireless solutions</li>
              <li>Voice & data network integration</li>
              <li>Fully qualified technicians</li>
              <li>Minimal disruption to your business</li>
              <li>Project management for real peace of mind</li>
              <li>Tested and Certified</li>
            </ul>
          </Typography>
          <Typography variant="body1" gutterBottom>
            Cable Testing Certification
          </Typography>
          <Typography variant="body1" gutterBottom>
            Testing and Certification are the most important steps in any cable installation. Because today’s Fast Ethernet transmission speeds "push the envelope" of any cabling system, it is critical that all components be thoroughly tested. Plugging the network equipment together and verifying that it "works" is not enough. Certification is especially important to prevent expensive upgrades to your cabling system when upgrading to faster networking technologies in the future. NEPTUNE TECHNOLOGY PTE. LTD. provides cable installation, testing and certification services designed to meet the highest performance standards. Installation of these components is performed in accordance with the recognized IMDA (INFOCOM MEDIA DEVELOPMENT AUTHORITY) standard.
          </Typography>
        </Paper>
      </Grid>
    </Grid>
  );
}

export default TechSpecs;